/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailshintaction3Inputs */

const en_companydetailshintaction3 = /** @type {(inputs: Companydetailshintaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add them`)
};

const de_companydetailshintaction3 = /** @type {(inputs: Companydetailshintaction3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergänzen`)
};

/**
* | output |
* | --- |
* | "Add them" |
*
* @param {Companydetailshintaction3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailshintaction3 = /** @type {((inputs?: Companydetailshintaction3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailshintaction3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailshintaction3(inputs)
	return de_companydetailshintaction3(inputs)
});
export { companydetailshintaction3 as "companyDetailsHintAction" }